export default __webpack_public_path__ + "static/media/clio_icon_broad_casting.00df87d3.svg";